import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const User: BleskIcon = forwardRef(function User(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M12.0003 7.22003C13.1054 7.22003 14.0012 8.11584 14.0012 9.22087C14.0012 10.3259 13.1054 11.2217 12.0003 11.2217C10.8953 11.2217 9.99951 10.3259 9.99951 9.22087C9.99951 8.11584 10.8953 7.22003 12.0003 7.22003"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0019 15.0012C15.8855 14.7085 15.705 14.4456 15.4736 14.2319V14.2319C15.0838 13.8695 14.5713 13.668 14.0391 13.6677H9.96235C9.4298 13.668 8.91703 13.8695 8.52676 14.2319V14.2319C8.2959 14.4461 8.11549 14.7088 7.99854 15.0012"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0012 19.0029H18.0028C19.6604 19.0029 21.0041 17.6592 21.0041 16.0016V5.99747C21.0041 4.33992 19.6604 2.99622 18.0028 2.99622H5.99783C4.34029 2.99622 2.99658 4.33992 2.99658 5.99747V16.0016C2.99658 17.6592 4.34029 19.0029 5.99783 19.0029H9.9995L12.0003 21.0037L14.0012 19.0029Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
